import { ActionSheetItem, ActionSheetWrapper, Button, Icon } from '@ketch-com/deck'
import { ProcessingActivityAssessmentRequirementDTO } from '@ketch-com/figurehead'
import { Typography } from '@mui/material'
import { useState } from 'react'

interface AssessmentWidgetEmptyStateActionSheetProps {
  pending: boolean
  updateAssessmentRequirement: (
    activityId: string,
    newRequirement: ProcessingActivityAssessmentRequirementDTO,
  ) => Promise<void>
  processingActivityId: string
  assessmentRequirement?: ProcessingActivityAssessmentRequirementDTO
}

export const AssessmentWidgetEmptyStateActionSheet = ({
  pending,
  updateAssessmentRequirement,
  processingActivityId,
  assessmentRequirement,
}: AssessmentWidgetEmptyStateActionSheetProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const open = Boolean(anchorEl)
  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const listData = [
    {
      label: 'Change To Recommended',
      requirement: ProcessingActivityAssessmentRequirementDTO.RecommendedProcessingActivityAssessmentRequirement,
      onClick: () => {
        updateAssessmentRequirement(
          processingActivityId || '',
          ProcessingActivityAssessmentRequirementDTO.RecommendedProcessingActivityAssessmentRequirement,
        )
        handleClose()
      },
    },
    {
      label: 'Change To Not Required',
      requirement: ProcessingActivityAssessmentRequirementDTO.NotRequiredProcessingActivityAssessmentRequirement,
      onClick: () => {
        updateAssessmentRequirement(
          processingActivityId || '',
          ProcessingActivityAssessmentRequirementDTO.NotRequiredProcessingActivityAssessmentRequirement,
        )
        handleClose()
      },
    },
    {
      label: 'Change To Required',
      requirement: ProcessingActivityAssessmentRequirementDTO.RequiredProcessingActivityAssessmentRequirement,
      onClick: () => {
        updateAssessmentRequirement(
          processingActivityId || '',
          ProcessingActivityAssessmentRequirementDTO.RequiredProcessingActivityAssessmentRequirement,
        )
        handleClose()
      },
    },
  ]

  return (
    <>
      <Button size="medium" onClick={handleClickListItem} variant="iconSubtle" color="tertiary" pending={pending}>
        <Icon name="OMore" />
      </Button>
      <ActionSheetWrapper anchorEl={anchorEl} open={open} onClose={handleClose} transitionDuration={0}>
        {listData.map((item, index) => {
          if (item.requirement === assessmentRequirement) {
            return null
          }
          return (
            <>
              <ActionSheetItem onClick={item.onClick}>
                <Typography>{item.label}</Typography>
              </ActionSheetItem>
              {index !== listData.length - 1 && <ActionSheetItem divider />}
            </>
          )
        })}
      </ActionSheetWrapper>
    </>
  )
}
